<script setup lang="ts">
import { VuePDF, usePDF } from "@tato30/vue-pdf";
interface PdfPreviewProps {
  link: string;
}

const { link } = defineProps<PdfPreviewProps>();


const { pdf, pages } = usePDF({
  url: link
});
</script>

<template>
  <div
    v-for="page in pages"
    :key="page"
  >
    <VuePDF
      :pdf="pdf"
      :page="page"
      fit-parent
    />
  </div>
</template>

<style scoped lang="scss">

</style>
